import {
  ChevronLeft,
  ChevronRight,
  ChevronsLeft,
  ChevronsRight,
} from "lucide-react";
import { Button } from "../../../components/ui/button";
import {
  PAGINATION_BTN_CLS,
  REQUIREMENT_LIST_COPY,
} from "./utilities";

export interface RequirementPaginationProps {
  page: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  rangeStart: number;
  rangeEnd: number;
  totalFiltered: number;
}

export function RequirementPagination({
  page,
  totalPages,
  onPageChange,
  rangeStart,
  rangeEnd,
  totalFiltered,
}: RequirementPaginationProps) {
  const disabledFirst = page === 1;
  const disabledLast = page === totalPages;

  const goToFirst = () => onPageChange(1);
  const goToPrev = () => onPageChange(Math.max(1, page - 1));
  const goToNext = () => onPageChange(Math.min(totalPages, page + 1));
  const goToLast = () => onPageChange(totalPages);

  return (
    <div className="flex flex-col gap-2 pt-1 sm:flex-row sm:items-center sm:justify-between">
      <p className="text-[11px] text-muted-foreground">
        {REQUIREMENT_LIST_COPY.showingPrefix} {rangeStart}-{rangeEnd} of{" "}
        {totalFiltered}
      </p>
      {totalPages > 1 && (
        <div className="flex items-center gap-1">
          <Button
            type="button"
            variant="outline"
            size="none"
            onClick={goToFirst}
            disabled={disabledFirst}
            className={PAGINATION_BTN_CLS}
            aria-label="First page"
          >
            <ChevronsLeft className="size-3.5" />
          </Button>
          <Button
            type="button"
            variant="outline"
            size="none"
            onClick={goToPrev}
            disabled={disabledFirst}
            className={PAGINATION_BTN_CLS}
            aria-label="Previous page"
          >
            <ChevronLeft className="size-3.5" />
          </Button>
          <span className="px-2 text-[11.5px] font-semibold text-foreground tabular-nums">
            {page} / {totalPages}
          </span>
          <Button
            type="button"
            variant="outline"
            size="none"
            onClick={goToNext}
            disabled={disabledLast}
            className={PAGINATION_BTN_CLS}
            aria-label="Next page"
          >
            <ChevronRight className="size-3.5" />
          </Button>
          <Button
            type="button"
            variant="outline"
            size="none"
            onClick={goToLast}
            disabled={disabledLast}
            className={PAGINATION_BTN_CLS}
            aria-label="Last page"
          >
            <ChevronsRight className="size-3.5" />
          </Button>
        </div>
      )}
    </div>
  );
}
